import React, { useEffect, useMemo, useState } from "react";
import { Checkbox, Button, Spin } from "antd";
import { formatNumberWithDots, calculateTimeDifference } from "../../helpers/utils";
import moment from "moment";
import { dateFilterAir, formatDateNoTime, formatTime } from "../../helpers/formatDate";
import _ from "lodash";
import { DoubleRightOutlined } from "@ant-design/icons";

const plainChairOptions = [
    { label: "Phổ thông", value: 1 },
    { label: "Phổ thông đặc biệt", value: 2 },
    { label: "Thương gia", value: 3 },
];

const timeOptions = [
    { label: "Trước 06:00", value: 1 },
    { label: "06:00 - 12:00", value: 2 },
    { label: "12:00 - 18:00", value: 3 },
    { label: "Sau 18:00", value: 4 },
];

const defaultChairCheckedList = [1, 2, 3];

const DesktopStep2 = ({
    onChangeStep, listFilght, setChooseFlight, chooseFlight, tripType,
    airport, airports, setStep, filterDay, setFilterDay, filterDayReturn,
    setFilterDayReturn, loadingSearchFlight, onBackButton, ChoosingStep, setChoosingStep,
}) => {
    const [checkedList, setCheckedList] = useState([]);
    const [filterTime, setFilterTime] = useState("");
    const [checkedListChair, setCheckedListChair] = useState(defaultChairCheckedList);
    const [plainOptions, setPlainOptions] = useState([]);
    const [typeSort, setTypeSort] = useState("price");
    const [sortIncrease, setSortIncrease] = useState(true);
    const [sortedFlights, setSortedFlights] = useState([]);
    const [filteredFlights, setFilteredFlights] = useState([]);
    const [visibleFlightClass, setVisibleFlightClass] = useState({});
    const [groupedFlights, setGroupedFlights] = useState([]);
    const [filterDayOriginal] = useState(filterDay);
    const [activeDay, setActiveDay] = useState(filterDay);
    const [startDayCalender, setStartDayCalender] = useState(filterDay);
    const [rangeOriginal, setRangeOriginal] = useState(0);
    const [rangCalender, setRangCalender] = useState(0);

    useEffect(() => {
        if (filterDayReturn) {
            const daysDifference = moment(filterDayReturn).diff(moment(filterDay), "days");
            setRangCalender(Math.max(daysDifference, 5));
            setRangeOriginal(Math.max(daysDifference, 5));
        } else { setRangCalender(5); }
    }, [filterDay, filterDayReturn]);

    const handleFilterTime = (filteredData) => {
        const getTimeRange = (startHour, endHour) => ({
            start: moment().hour(startHour).minute(0).second(0),
            end: endHour ? moment().hour(endHour).minute(0).second(0) : undefined,
        });
        if (filterTime) {
            return filteredData.filter((item) => {
                const timeStartAir = moment(item.options?.[0]?.flights?.[0]?.startdate).set({ year: moment().year(), month: moment().month(), date: moment().date() });
                const timeRanges = { 1: getTimeRange(0, 6), 2: getTimeRange(6, 12), 3: getTimeRange(12, 18), 4: getTimeRange(18) };
                const { start, end } = timeRanges[filterTime] || {};
                return end ? start <= timeStartAir && end >= timeStartAir : start <= timeStartAir;
            });
        }
        return filteredData;
    };

    const handleFilter = () => {
        const filteredData = sortedFlights.filter((item) => checkedList.includes(item.airline.code));
        const filteredTime = handleFilterTime(filteredData);
        const sortedData = filteredTime.sort((a, b) => {
            if (typeSort === "price") return sortIncrease ? a.totalprice - b.totalprice : b.totalprice - a.totalprice;
            if (typeSort === "timeStart") {
                const startdateA = new Date(a?.options?.[0]?.flights?.[0]?.startdate);
                const startdateB = new Date(b?.options?.[0]?.flights?.[0]?.startdate);
                return sortIncrease ? startdateA - startdateB : startdateB - startdateA;
            }
            return sortIncrease ? a.totalprice - b.totalprice : b.totalprice - a.totalprice;
        });
        setFilteredFlights(sortedData);
    };

    useEffect(() => { handleFilter(); }, [sortIncrease, sortedFlights, typeSort, checkedList, filterTime]);

    useEffect(() => {
        if (tripType === "oneWay") { setSortedFlights(ChoosingStep === 1 ? listFilght : []); }
        else {
            if (ChoosingStep === 1) setSortedFlights(listFilght.filter((item) => item.options?.[0]?.flights?.[0]?.startpoint === airport[0]));
            else if (ChoosingStep === 2) setSortedFlights(listFilght.filter((item) => item.options?.[0]?.flights?.[0]?.startpoint === airport[1]));
            else setSortedFlights([]);
        }
        const airlines = listFilght.reduce((acc, flight) => {
            if (!_.some(acc, (item) => item.label === flight.airline.name)) {
                acc.push({ label: flight.airline.name, image: `${process.env.REACT_APP_BASE_URL}/${flight.airline.iconurl}`, value: flight.airline.code });
            }
            return acc;
        }, []);
        setPlainOptions(airlines);
        setCheckedList(_.map(airlines, (air) => air.value));
    }, [ChoosingStep, listFilght, airport, tripType]);

    useEffect(() => {
        const groupFlightsByClass = (fareDataList) => {
            const grouped = fareDataList.reduce((acc, currentFareData) => {
                const flightInfo = currentFareData?.options?.[0]?.flights?.[0];
                const key = `${flightInfo?.startdate}-${currentFareData?.airline?.code}`;
                if (!acc[key]) acc[key] = { startdate: flightInfo?.startdate, airline: currentFareData.airline, flights: [] };
                acc[key].flights.push(currentFareData);
                return acc;
            }, {});
            return Object.values(grouped);
        };
        setGroupedFlights(groupFlightsByClass(filteredFlights));
    }, [filteredFlights]);

    const handleSort = (type) => { setTypeSort(type); setSortIncrease((prev) => (type === typeSort ? !prev : true)); };

    const handleSelectTicket = (item) => {
        if (tripType === "oneWay") {
            if (ChoosingStep === 1) { setChooseFlight([item]); setChoosingStep(3); onChangeStep(3); }
        } else {
            if (ChoosingStep === 1) { setChooseFlight([item]); setChoosingStep(2); setActiveDay(filterDayReturn); setStartDayCalender(filterDayReturn); }
            else if (ChoosingStep === 2) { setChooseFlight([...chooseFlight, item]); setChoosingStep(3); onChangeStep(3); }
        }
    };

    const selectFilterDay = (currentDate) => {
        if (ChoosingStep === 3) return;
        if (ChoosingStep === 1) setFilterDay(dateFilterAir(currentDate));
        else setFilterDayReturn(dateFilterAir(currentDate));
    };

    return (
        <div className="desktop-step2-container" style={{ minHeight: '100vh', background: '#f0f4f8', display: 'flex', flexDirection: 'column', fontFamily: "'Inter', sans-serif" }}>

            {/* Header */}
            <header style={{
                background: 'linear-gradient(135deg, #0f172a, #1e3a5f)', color: 'white',
                padding: '16px 32px', boxShadow: '0 2px 12px rgba(0,0,0,0.15)',
                position: 'sticky', top: 0, zIndex: 50, display: 'flex', justifyContent: 'space-between', alignItems: 'center'
            }}>
                <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
                    <div onClick={onBackButton} style={{
                        cursor: 'pointer', background: 'rgba(255,255,255,0.1)', padding: '8px', borderRadius: '50%', transition: 'all 0.2s'
                    }}>
                        <svg style={{ width: '20px', height: '20px', color: 'white' }} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" /></svg>
                    </div>
                    <div>
                        <h1 style={{ fontSize: '20px', fontWeight: 700, margin: 0, lineHeight: 1.2, color: 'white' }}>
                            {airport[0]} <DoubleRightOutlined style={{ fontSize: '12px', margin: '0 8px', color: 'white' }} /> {airport[1]}
                        </h1>
                        <div style={{ color: '#93c5fd', fontSize: '13px', marginTop: '2px' }}>{tripType === 'roundTrip' ? 'Khứ hồi' : 'Một chiều'}</div>
                    </div>
                </div>

                {/* Date Carousel */}
                <div className="custom-scrollbar" style={{ display: 'flex', gap: '8px', overflow: 'auto', paddingBottom: '2px', maxWidth: '60%' }}>
                    {Array(rangCalender + 1).fill("").map((_, index) => {
                        const currentDate = moment(startDayCalender, "YYYY-MM-DD").add(Math.abs(index), "days");
                        const isActive = activeDay === dateFilterAir(currentDate);
                        return (
                            <div key={index} onClick={() => { setActiveDay(dateFilterAir(currentDate)); selectFilterDay(currentDate); }}
                                style={{
                                    minWidth: '90px', cursor: 'pointer', borderRadius: '10px',
                                    border: isActive ? '2px solid white' : '1px solid rgba(255,255,255,0.2)',
                                    padding: '8px 12px', display: 'flex', flexDirection: 'column', alignItems: 'center',
                                    justifyContent: 'center', transition: 'all 0.2s',
                                    background: isActive ? 'white' : 'transparent',
                                    color: isActive ? '#1e3a5f' : 'rgba(255,255,255,0.8)',
                                    fontWeight: isActive ? 700 : 400, boxShadow: isActive ? '0 4px 12px rgba(0,0,0,0.2)' : 'none'
                                }}>
                                <div style={{ fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>{moment(currentDate).isSame(moment(), "day") ? "Hôm nay" : ["CN", "T2", "T3", "T4", "T5", "T6", "T7"][currentDate.day()]}</div>
                                <div style={{ fontSize: '16px', fontWeight: 600 }}>{currentDate.format("DD/MM")}</div>
                            </div>
                        );
                    })}
                </div>
            </header>

            {/* Content Area */}
            <div style={{ display: 'flex', padding: '24px 32px', gap: '24px', maxWidth: '1400px', width: '100%', margin: '0 auto' }}>

                {/* Sidebar Filter */}
                <div style={{ width: '280px', flexShrink: 0, position: 'sticky', top: '100px', height: 'fit-content' }}>
                    <div style={{ background: 'white', borderRadius: '16px', boxShadow: '0 1px 3px rgba(0,0,0,0.06)', border: '1px solid #e2e8f0', padding: '20px', marginBottom: '16px' }}>
                        <h2 style={{ fontSize: '17px', fontWeight: 700, color: '#1e293b', marginBottom: '16px', paddingBottom: '12px', borderBottom: '1px solid #e2e8f0' }}>Lọc kết quả</h2>

                        <div style={{ marginBottom: '20px' }}>
                            <h3 style={{ fontWeight: 600, color: '#475569', marginBottom: '12px', fontSize: '14px' }}>Hãng hàng không</h3>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                {plainOptions.map((item) => (
                                    <Checkbox key={item.value}
                                        onChange={() => setCheckedList(prev => prev.includes(item.value) ? prev.filter(v => v !== item.value) : [...prev, item.value])}
                                        checked={checkedList.includes(item.value)}
                                        style={{ color: '#475569', fontWeight: 500 }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <img src={item.image} alt={item.label} style={{ width: '24px', height: '24px', objectFit: 'contain' }} />
                                            <span style={{ fontSize: '14px' }}>{item.label}</span>
                                        </div>
                                    </Checkbox>
                                ))}
                            </div>
                        </div>

                        <div>
                            <h3 style={{ fontWeight: 600, color: '#475569', marginBottom: '12px', fontSize: '14px' }}>Thời gian bay</h3>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                {timeOptions.map((item) => (
                                    <div key={item.value} onClick={() => setFilterTime(filterTime === item.value ? "" : item.value)}
                                        style={{
                                            padding: '8px 12px', border: `1px solid ${filterTime === item.value ? '#3b82f6' : '#e2e8f0'}`,
                                            borderRadius: '8px', cursor: 'pointer', transition: 'all 0.2s', fontSize: '13px',
                                            fontWeight: 500, textAlign: 'center',
                                            background: filterTime === item.value ? '#eff6ff' : 'white',
                                            color: filterTime === item.value ? '#2563eb' : '#475569'
                                        }}>
                                        {item.label}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    {ChoosingStep === 2 && chooseFlight[0] && (
                        <div style={{
                            background: 'linear-gradient(160deg, #1e3a5f, #0f172a)', borderRadius: '16px',
                            boxShadow: '0 4px 15px rgba(0,0,0,0.15)', padding: '20px', color: 'white'
                        }}>
                            <h3 style={{ fontWeight: 700, fontSize: '12px', color: '#93c5fd', marginBottom: '8px', letterSpacing: '1px' }}>ĐÃ CHỌN CHIỀU ĐI</h3>
                            <div style={{ fontWeight: 700, fontSize: '18px', marginBottom: '4px' }}>{formartRoute(chooseFlight[0])}</div>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '13px', borderTop: '1px solid rgba(255,255,255,0.15)', paddingTop: '8px', marginTop: '8px' }}>
                                <span>{formatDateNoTime(chooseFlight[0]?.options?.[0]?.flights?.[0]?.startdate)}</span>
                                <span style={{ fontWeight: 700, color: '#fbbf24' }}>{formatNumberWithDots(chooseFlight[0]?.totalprice)} đ</span>
                            </div>
                            <button onClick={() => { setChoosingStep(1); setChooseFlight([]); setActiveDay(filterDayOriginal); setStartDayCalender(filterDayOriginal); }}
                                style={{
                                    width: '100%', marginTop: '12px', background: 'rgba(255,255,255,0.15)', color: 'white',
                                    fontWeight: 500, padding: '8px', borderRadius: '8px', border: 'none', cursor: 'pointer', fontSize: '13px'
                                }}>
                                Đổi chuyến
                            </button>
                        </div>
                    )}
                </div>

                {/* Main Content - Flight List */}
                <div style={{ flex: 1, minWidth: 0 }}>
                    {/* Sort Bar */}
                    <div style={{ background: 'white', borderRadius: '12px', boxShadow: '0 1px 3px rgba(0,0,0,0.06)', border: '1px solid #e2e8f0', padding: '14px 20px', marginBottom: '16px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <h2 style={{ fontWeight: 700, fontSize: '17px', color: '#1e293b', margin: 0 }}>
                            {ChoosingStep === 1 ? 'Chọn chuyến đi' : (ChoosingStep === 2 ? 'Chọn chuyến về' : 'Hoàn tất')}
                        </h2>
                        <div style={{ display: 'flex', gap: '8px' }}>
                            <Button onClick={() => handleSort("price")} style={{
                                borderRadius: '20px', padding: '0 20px', fontWeight: 600, fontSize: '13px',
                                borderColor: typeSort === 'price' ? '#f97316' : '#e2e8f0',
                                color: typeSort === 'price' ? '#ea580c' : '#64748b',
                                background: typeSort === 'price' ? '#fff7ed' : 'white'
                            }}>
                                Giá vé {typeSort === "price" && (sortIncrease ? '↑' : '↓')}
                            </Button>
                            <Button onClick={() => handleSort("timeStart")} style={{
                                borderRadius: '20px', padding: '0 20px', fontWeight: 600, fontSize: '13px',
                                borderColor: typeSort === 'timeStart' ? '#3b82f6' : '#e2e8f0',
                                color: typeSort === 'timeStart' ? '#2563eb' : '#64748b',
                                background: typeSort === 'timeStart' ? '#eff6ff' : 'white'
                            }}>
                                Giờ cất cánh {typeSort === "timeStart" && (sortIncrease ? '↑' : '↓')}
                            </Button>
                        </div>
                    </div>

                    {/* Progressive Loading Spinner */}
                    {loadingSearchFlight && groupedFlights.length > 0 && (
                        <div style={{ background: '#eff6ff', borderRadius: '12px', padding: '12px 20px', marginBottom: '16px', display: 'flex', alignItems: 'center', gap: '12px', border: '1px solid #bfdbfe' }}>
                            <Spin size="small" />
                            <span style={{ color: '#1d4ed8', fontSize: '14px', fontWeight: 500 }}>Hệ thống đang tiếp tục tìm chuyến bay...</span>
                        </div>
                    )}

                    {/* Flight Cards */}
                    {loadingSearchFlight && groupedFlights.length === 0 ? (
                        <div style={{ background: 'white', borderRadius: '16px', boxShadow: '0 1px 3px rgba(0,0,0,0.06)', border: '1px solid #e2e8f0', padding: '60px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <Spin size="large" />
                            <h3 style={{ marginTop: '24px', fontSize: '18px', fontWeight: 700, color: '#1e293b' }}>Đang tìm chuyến bay tốt nhất...</h3>
                            <p style={{ color: '#64748b', marginTop: '8px' }}>Vui lòng đợi trong giây lát</p>
                        </div>
                    ) : groupedFlights.length === 0 ? (
                        <div style={{ background: 'white', borderRadius: '16px', boxShadow: '0 1px 3px rgba(0,0,0,0.06)', border: '1px solid #e2e8f0', padding: '60px', textAlign: 'center' }}>
                            <div style={{ fontSize: '48px', marginBottom: '16px' }}>✈️</div>
                            <h3 style={{ fontSize: '18px', fontWeight: 700, color: '#1e293b' }}>Không tìm thấy chuyến bay</h3>
                            <p style={{ color: '#64748b', marginTop: '8px' }}>Thử thay đổi ngày bay hoặc bộ lọc.</p>
                        </div>
                    ) : (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                            {groupedFlights.map((group, groupIndex) => {
                                const flightGroupInfo = group.flights[0]?.options?.[0]?.flights?.[0];
                                const isExpanded = visibleFlightClass[groupIndex];
                                const minPriceFlight = _.minBy(group.flights, 'totalprice');

                                return (
                                    <div key={groupIndex} style={{
                                        background: 'white', borderRadius: '16px', boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
                                        border: `1px solid ${isExpanded ? '#93c5fd' : '#e2e8f0'}`, overflow: 'hidden', transition: 'all 0.25s'
                                    }}>
                                        {/* Summary Row */}
                                        <div onClick={() => setVisibleFlightClass(p => ({ ...p, [groupIndex]: !p[groupIndex] }))}
                                            style={{ padding: '20px 24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', cursor: 'pointer' }}>
                                            <div style={{ display: 'flex', width: '25%', alignItems: 'center', gap: '14px' }}>
                                                <img src={`${process.env.REACT_APP_BASE_URL}/${group.airline.iconurl}`} alt="" style={{ width: '44px', height: '44px', objectFit: 'contain' }} />
                                                <div>
                                                    <div style={{ fontWeight: 700, color: '#1e293b', fontSize: '15px' }}>{group.airline.name}</div>
                                                    <div style={{ fontSize: '12px', color: '#94a3b8', fontWeight: 500 }}>{flightGroupInfo?.segments?.[0]?.flightnumber}</div>
                                                </div>
                                            </div>

                                            <div style={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '0 32px' }}>
                                                <div style={{ textAlign: 'right', marginRight: '20px' }}>
                                                    <div style={{ fontSize: '22px', fontWeight: 700, color: '#1e293b' }}>{formatTime(flightGroupInfo?.startdate)}</div>
                                                    <div style={{ fontSize: '13px', fontWeight: 600, color: '#64748b', background: '#f1f5f9', borderRadius: '4px', padding: '1px 6px' }}>{flightGroupInfo?.startpoint}</div>
                                                </div>
                                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flex: 1, maxWidth: '180px' }}>
                                                    <span style={{ fontSize: '11px', color: '#94a3b8', fontWeight: 500, marginBottom: '4px' }}>{calculateTimeDifference(flightGroupInfo?.startdate, flightGroupInfo?.enddate)}</span>
                                                    <div style={{ width: '100%', position: 'relative', display: 'flex', alignItems: 'center' }}>
                                                        <div style={{ height: '2px', width: '100%', background: '#bfdbfe' }} />
                                                        <svg style={{ width: '18px', height: '18px', color: '#3b82f6', position: 'absolute', left: '50%', transform: 'translateX(-50%)' }} fill="currentColor" viewBox="0 0 24 24"><path d="M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z" /></svg>
                                                    </div>
                                                    <span style={{ fontSize: '10px', color: '#16a34a', fontWeight: 700, marginTop: '4px', background: '#f0fdf4', padding: '1px 8px', borderRadius: '12px' }}>
                                                        {flightGroupInfo?.stopnum === 0 ? "Bay thẳng" : `${flightGroupInfo.stopnum} điểm dừng`}
                                                    </span>
                                                </div>
                                                <div style={{ textAlign: 'left', marginLeft: '20px' }}>
                                                    <div style={{ fontSize: '22px', fontWeight: 700, color: '#1e293b' }}>{formatTime(flightGroupInfo?.enddate)}</div>
                                                    <div style={{ fontSize: '13px', fontWeight: 600, color: '#64748b', background: '#f1f5f9', borderRadius: '4px', padding: '1px 6px' }}>{flightGroupInfo?.endpoint}</div>
                                                </div>
                                            </div>

                                            <div style={{ width: '25%', display: 'flex', flexDirection: 'column', alignItems: 'flex-end', borderLeft: '1px solid #e2e8f0', paddingLeft: '24px' }}>
                                                <div style={{ fontSize: '12px', color: '#94a3b8', marginBottom: '4px' }}>Giá từ</div>
                                                <div style={{ fontSize: '22px', fontWeight: 800, color: '#f97316' }}>{formatNumberWithDots(minPriceFlight?.totalprice)} <span style={{ fontSize: '14px', fontWeight: 400, textDecoration: 'underline' }}>đ</span></div>
                                                <Button type="link" style={{ marginTop: '4px', fontWeight: 600, padding: 0, fontSize: '13px' }}>
                                                    {isExpanded ? 'Thu gọn' : 'Chọn hạng vé'}
                                                </Button>
                                            </div>
                                        </div>

                                        {/* Expanded Fare Classes */}
                                        {isExpanded && (
                                            <div style={{ background: '#f8fafc', borderTop: '1px solid #e2e8f0' }}>
                                                <div style={{ padding: '16px 20px', display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '12px' }}>
                                                    {group.flights.map((fare, idx) => (
                                                        <div key={idx} style={{
                                                            background: 'white', borderRadius: '12px', border: '1px solid #e2e8f0',
                                                            padding: '16px', transition: 'all 0.2s', display: 'flex', flexDirection: 'column', cursor: 'pointer'
                                                        }}>
                                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '8px', borderBottom: '1px solid #f1f5f9', paddingBottom: '8px' }}>
                                                                <div>
                                                                    <div style={{ fontWeight: 700, color: '#1e293b', fontSize: '14px' }}>{fare?.options?.[0]?.flights?.[0]?.segments?.[0]?.fareclassname || 'Phổ thông'}</div>
                                                                    <div style={{ fontSize: '12px', color: '#94a3b8', marginTop: '4px', display: 'flex', alignItems: 'center', gap: '4px' }}>
                                                                        <svg style={{ width: '12px' }} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" /></svg>
                                                                        7kg xách tay
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div style={{ flex: 1 }} />
                                                            <div style={{ marginTop: '12px', display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between' }}>
                                                                <div style={{ fontSize: '18px', fontWeight: 800, color: '#ea580c' }}>{formatNumberWithDots(fare.totalprice)}<span style={{ fontSize: '12px' }}>đ</span></div>
                                                                <Button type="primary" onClick={(e) => { e.stopPropagation(); handleSelectTicket(fare); }}
                                                                    style={{ background: 'linear-gradient(135deg, #f97316, #ea580c)', border: 'none', fontWeight: 700, borderRadius: '8px', fontSize: '13px' }}>
                                                                    Chọn vé
                                                                </Button>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

const formartRoute = (flightData) => {
    try { return `${flightData?.options?.[0]?.flights?.[0]?.startpoint} → ${flightData?.options?.[0]?.flights?.[0]?.endpoint}` }
    catch { return "Chuyến đi" }
};

export default DesktopStep2;
